import {
	axiosApi,
	uploadApi
} from "./api"

// 登录
export const getlogin = function (tel,psw) {
    return axiosApi("post", "/user/tel/login")({
        tel, psw
    })
}
//项目列表
export const getProjectList = function (pageNo,pageSize) {
    return axiosApi("get", "/project/list")({
        pageNo, pageSize
    })
}
//创建项目
export const getNewProject = function (name,desc,file) {
    let data = new FormData()
    data.append("thumbnail", file)
    return uploadApi("/project/add?name="+name+"&desc="+desc)(data)
}

//删除项目
export const deleteProject = function (id) {
    return axiosApi("post", "/project/delete")({
        id
    })
}

//修改项目
export const updateProject = function (obj) {
    return axiosApi("post", "/project/update",true)(obj)
}

//文件列表
export const getModelList = function (obj) {
    return axiosApi("get", "/model/list")(obj)
}

//文件创建
export const AddModel= function (obj) {
    let data = new FormData()
    data.append("modelFile", obj.modelFile)
    data.append("thumbnail", obj.thumbnail)
    return uploadApi("/model/add?name="+obj.name+"&projectId="+obj.projectId)(data)
}

//文件转换
export const getModelState = function (fileId) {
    return axiosApi("get", "/model/translateState")({fileId})
}

//文件预览
export const getModelView = function (fileId) {
    return axiosApi("get", "/model/view")({fileId})
}

//删除文件
export const deleteModel = function (id) {
    return axiosApi("post", "/model/delete")({id})
}





// WEBPACK FOOTER //
// ./src/api/common.js